// extracted by mini-css-extract-plugin
export default {"container":"loading_container__J5vMa","items":"loading_items__htr2J"};